import { useEffect, useState } from "react";

export function useIsMobile(bp = 768) {
  const [m, setM] = useState(() => window.matchMedia(`(max-width: ${bp - 1}px)`).matches);
  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${bp - 1}px)`);
    const fn = (e) => setM(e.matches);
    mq.addEventListener("change", fn);
    return () => mq.removeEventListener("change", fn);
  }, [bp]);
  return m;
}
